<ng-container *ngIf="loading">
  <mat-spinner class="init-spinner" color="primary" diameter="75"></mat-spinner>
</ng-container>
<div class="flex-column h-100" *ngIf="!loading && tour != null">
  <div class="placer-name-banner">
    <div class="placer-name">
      <span>
        {{ placer?.user?.firstName | personName : placer?.user?.lastName }}
        -
        {{ tourDate | formatMoment : '' : 'DD MMMM YYYY' }}
      </span>
      <impersonate-icon
        class="impersonate-icon"
        [user]="placer?.user"
        (click)="close()"
      >
      </impersonate-icon>
    </div>
  </div>
  <div class="d-flex upper-space h-100">
    <div class="flex-table">
      <div *ngIf="editingTour" class="employee-tour-loader-overlay">
        <div class="overlay-spinner">
          <mat-spinner color="primary" diameter="75"></mat-spinner>
        </div>
      </div>
      <div class="table-container panel">
        <table
          #table
          mat-table
          class="example-table"
          [dataSource]="tour.tourItems"
          cdkDropList
          [cdkDropListData]="tour.tourItems"
          [cdkDropListDisabled]="tour.routeChecked"
          (cdkDropListDropped)="onListDrop($event)"
        >
          <ng-container matColumnDef="index">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Nr</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row; let i = index"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <span>{{ i + 1 }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="projectId">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Jobnr</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <ng-container *ngIf="row.subProject != null">
                <span>{{
                  row.subProject.project?.id == null
                    ? ''
                    : row.subProject.project.id
                }}</span>
                <span
                  *ngIf="row.subProject.project?.oldPlatformId != null"
                  class="font-weight-bold font-italic"
                  [matTooltip]="'Jobnummer oud platform'"
                >
                  ({{ row.subProject.project.oldPlatformId }})</span
                >
              </ng-container>
              <ng-container *ngIf="row.immoTask != null">
                {{ row.immoTask.id }}
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="currentCreatedAt">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Aanvraag</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <ng-container *ngIf="row.subProject != null">
                {{
                  row.subProject.currentCreatedAt | formatDate : '' : 'dd/MM'
                }}
              </ng-container>
              <ng-container *ngIf="row.immoTask != null">
                {{ row.immoTask.createdAt | formatDate : '' : 'dd/MM' }}
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="requested">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Gewenst</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <ng-container *ngIf="row.subProject != null">
                <div
                  *ngIf="
                    row.subProject.currentRequestASAP &&
                    row.subProject.currentRequestDate == null
                  "
                >
                  asap
                </div>
                <div
                  *ngIf="row.subProject.currentRequestDate != null"
                  class="important-text"
                >
                  {{
                    row.subProject.currentRequestDate
                      | formatDate : '' : 'd MMM yyyy'
                  }}
                </div>
                <div
                  *ngIf="
                    row.subProject.projectPlacement?.appointment &&
                    row.subProject.projectPlacement?.appointmentTime != null
                  "
                  class="important-text"
                >
                  {{
                    row.subProject.projectPlacement.appointmentTime
                      | slice : 0 : 5
                  }}
                </div>
                <div
                  *ngIf="
                    row.subProject.projectPlacement?.appointment &&
                    row.subProject.projectPlacement?.appointmentTime == null &&
                    row.subProject.projectPlacement?.appointmentTimeOfDay
                      ?.length > 0
                  "
                  class="important-text"
                >
                  {{ row.subProject.projectPlacement.appointmentTimeOfDay }}
                </div>
              </ng-container>
              <ng-container *ngIf="row.immoTask != null">
                <div *ngIf="row.immoTask.requestedASAP">asap</div>
                <div
                  *ngIf="row.immoTask.requestedDate != null"
                  class="important-text"
                >
                  {{
                    row.immoTask.requestedDate | formatDate : '' : 'd MMM yyyy'
                  }}
                </div>
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Klant</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <ng-container
                *ngIf="row.subProject?.project?.companyNames?.length > 0"
              >
                <div
                  *ngFor="
                    let companyName of row.subProject.project.companyNames
                  "
                >
                  {{ companyName }}
                </div>
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Adres</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <ng-container *ngIf="row.subProject != null">
                <div class="d-flex justify-content-between">
                  <div>
                    {{
                      row.subProject.projectPlacement?.address?.line1
                        | printAddress
                          : row.subProject.projectPlacement?.address?.postalCode
                          : row.subProject.projectPlacement?.address?.city
                    }}
                    <ng-container
                      *ngIf="
                        row.subProject.projectPlacement?.placementFloor
                          ?.length > 0
                      "
                    >
                      <br />
                      <small>{{
                        row.subProject.projectPlacement?.placementFloor
                      }}</small>
                    </ng-container>
                  </div>
                  <div class="d-flex">
                    <mat-icon
                      *ngIf="row.subProject.projectPlacement?.appointment"
                      class="info-icon mb-auto mt-auto"
                      [matTooltip]="
                        row.subProject.projectPlacement?.appoinmentTooltip
                      "
                      >info</mat-icon
                    >
                    <img
                      *ngIf="row.subProject.projectPlacement?.collectKey"
                      class="key-icon mb-auto mt-auto"
                      src="../../../../../../assets/collect-key.png"
                      [matTooltip]="
                        row.subProject.projectPlacement?.collectKeyTooltip
                      "
                    />
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="row.immoTask != null">{{
                row.immoTask.address?.line1
                  | printAddress
                    : row.immoTask.address?.postalCode
                    : row.immoTask.address?.city
              }}</ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Type</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <ng-container
                *ngIf="row.subProject?.project?.products?.length > 0"
              >
                <div *ngFor="let product of row.subProject.project.products">
                  <span
                    [matTooltip]="product.divergentBoardDisplay"
                    [matTooltipDisabled]="!product.isDivergentBoard"
                  >
                    {{ product.typeDisplay }}
                  </span>
                </div>
              </ng-container>
              <ng-container *ngIf="row.immoTask != null">{{
                row.immoTask.subject | shortenText : 30
              }}</ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Actie</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <ng-container *ngIf="row.subProject != null">
                <span class="status" [ngClass]="row.subProject.typeClass">{{
                  row.subProject.typeDisplay
                }}</span>
              </ng-container>
              <ng-container *ngIf="row.immoTask != null">
                <span *ngIf="row.immoTask.type === 'TASK'" class="status task"
                  >Taak</span
                >
                <span
                  *ngIf="row.immoTask.type === 'COLLECT_KEY'"
                  class="status collect-key"
                  >Sleutel</span
                >
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>Edit</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <ng-container *ngIf="row.subProject != null">
                <button
                  class="edit-button"
                  mat-button
                  type="button"
                  (click)="openSubProject(row)"
                >
                  Edit
                </button>
              </ng-container>
              <ng-container *ngIf="row.immoTask != null">
                <button
                  class="edit-button"
                  mat-button
                  type="button"
                  (click)="openTaskEditModal(row.immoTask)"
                >
                  Edit
                </button>
              </ng-container>
            </td>
          </ng-container>
          <ng-container matColumnDef="other">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b class="click-link" (click)="toggleAll()">A</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <div
                class="other-checkbox"
                [matTooltip]="'Kan niet wijzigen, is locked'"
                [matTooltipDisabled]="!row.locked"
              >
                <mat-checkbox
                  [ariaLabel]=""
                  [(ngModel)]="row.selected"
                  (ngModelChange)="tourItemSelectedChanged($event)"
                  [disabled]="row.locked"
                ></mat-checkbox>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="X">
            <th mat-header-cell *matHeaderCellDef class="header-text">
              <b>X</b>
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              class="table-text"
              [ngClass]="{
                'collect-key':
                  row.immoTask !== null && row.immoTask.type === 'COLLECT_KEY'
              }"
            >
              <span
                class="delete-button"
                [class.locked]="row.locked"
                (click)="removeItemFromTour(row)"
                [matTooltip]="'Kan niet verwijderen, is locked'"
                [matTooltipDisabled]="!row.locked"
                >X</span
              >
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            class="table-row"
            [class.executed]="row.executed === true"
            [class.not-executed]="row.executed === false"
            *matRowDef="let row; columns: displayedColumns"
            cdkDrag
            [cdkDragData]="row"
          ></tr>
        </table>
      </div>
      <div class="upper-space d-flex justify-content-between">
        <div>
          <div class="d-flex routeplanning-buttons">
            <mat-checkbox
              [(ngModel)]="tour.routeChecked"
              (ngModelChange)="routeCheckedChanged()"
              >Routeplanning intern opgemaakt</mat-checkbox
            >
            <button mat-button class="edit-button" (click)="optimizeRoute()">
              Route optimaliseren
            </button>
          </div>

          <button
            class="close-button all-width upper-space"
            mat-button
            type="button"
            (click)="close()"
          >
            Sluiten
          </button>
          <button
            mat-button
            class="action-button all-width"
            (click)="openCreateEditTaskModal()"
          >
            + Nieuwe taak
          </button>
        </div>
        <div class="other-tour">
          <div class="no-bottom-padding">
            <mat-form-field appearance="outline">
              <input
                matInput
                [min]="today"
                [matDatepicker]="otherTourDatePicker"
                placeholder="Selecteer een datum"
                [(ngModel)]="selectedDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="otherTourDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #otherTourDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="no-bottom-padding">
            <mat-form-field class="all-width" appearance="outline">
              <mat-select
                matInput
                placeholder="Kies een installateur"
                [(ngModel)]="selectedPlacer"
                name="otherTourPlacer"
                [compareWith]="compareEntities"
              >
                <mat-option
                  *ngFor="let option of placerOptions"
                  [value]="option"
                >
                  <span>{{
                    option.user?.firstName | personName : option.user?.lastName
                  }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="all-width smaller-upper-space">
            <button
              class="plan-button all-width"
              mat-button
              type="button"
              [disabled]="
                selectedDate == null ||
                selectedPlacer == null ||
                subProjectSelectedCount < 1
              "
              (click)="transferSelectedSubProjects()"
            >
              Inplannen
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-map">
      <employee-tour-map
        [items]="tourItemsForMap"
        [placerAddress]="placer.address"
      ></employee-tour-map>
    </div>
  </div>
</div>
